// extracted by mini-css-extract-plugin
export var root = "ContactForm-root-DZQS-";
export var rootCol = "ContactForm-root_col-3z4YO";
export var rootDescription = "ContactForm-root_description-KMGEE";
export var rootHeading = "ContactForm-root_heading-ADtzm";
export var rootIcon = "ContactForm-root_icon-JtMC4";